import { render, staticRenderFns } from "./device_page_mng.vue?vue&type=template&id=795337d4"
import script from "./device_page_mng.vue?vue&type=script&lang=js"
export * from "./device_page_mng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795337d4')) {
      api.createRecord('795337d4', component.options)
    } else {
      api.reload('795337d4', component.options)
    }
    module.hot.accept("./device_page_mng.vue?vue&type=template&id=795337d4", function () {
      api.rerender('795337d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_page_mng.vue"
export default component.exports